export default __webpack_public_path__ + "static/media/Dudas.cec21a1d.svg";